<template>
  <div class="ti">
    <div style="margin-left: 20px; margin-top: 20px; margin-bottom: 20px;background: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  justify-content: center;
  padding:10px 10px;
  position: sticky;
  top: 0;
  left: 0;
  z-index:999">
      <el-row>
        <el-col :span="2">
          <el-checkbox :indeterminate="isIndeterminate" v-model="search.checkAll" @change="handleCheckAllChange">
            全选
            <el-badge  class="mark" :value="status_total['total']" />
          </el-checkbox>
        </el-col>
        <el-col :span="19">
          <el-checkbox-group v-model="search.select_status" @change="handleCheckedCitiesChange">
            <template v-for="(item, index) in search.statusList" v-if="is400 == false">
              <el-checkbox  :label="item" :key="item">
                {{item}}
                <el-badge v-if="index == 0" class="mark" :value="status_total['status_0']" />
                <el-badge v-if="index == 1" class="mark" :value="status_total['status_2']" />
                <el-badge v-if="index == 2" class="mark" :value="status_total['status_7']" />
                <el-badge v-if="index == 3" class="mark" :value="status_total['status_3']" />
                <el-badge v-if="index == 4" class="mark" :value="status_total['status_3000']" />
                <el-badge v-if="index == 5" class="mark" :value="status_total['status_5']" />
                <el-badge v-if="index == 6" class="mark" :value="status_total['status_4']" />

              </el-checkbox>
            </template>
            <template v-for="(item, index) in search.status400List" v-if="is400 == true">
              <el-checkbox  :label="item" :key="item">
                {{item}}
                <el-badge v-if="index == 0" class="mark" :value="status_total['status_0']" />
                <el-badge v-if="index == 1" class="mark" :value="status_total['status_1']" />
                <el-badge v-if="index == 2" class="mark" :value="status_total['status_10']" />
                <el-badge v-if="index == 3" class="mark" :value="status_total['status_100']" />
              </el-checkbox>
            </template>
          </el-checkbox-group>
        </el-col>
<!--        <el-col :span="3">-->
<!--          <el-button size="mini" style="color: #FFFFFF" type="primary" @click="searchData">搜索</el-button>-->
<!--        </el-col>-->
      </el-row>
      <el-row>
        <el-col :span="24">
          <SelectCdjProjectHeader :items="['type_id', 'place_id','region_id','project_id', 'area_id']" @onHeader="onHeader"></SelectCdjProjectHeader>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4" v-show="is400 == false">
          编号：
          <el-input size="mini" v-model="search.services_id" placeholder="请输入编号" style="width: 80%" @input="searchData"></el-input>
        </el-col>
        <el-col :span="4" v-show="is400 == false">
          类型：
          <el-select v-model="search.type" placeholder="请选择类型" size="mini" clearable @change="searchData">
            <el-option label="-所有类型-" value=""></el-option>
            <el-option label="服务态度" value="4"></el-option>
            <el-option label="公区维修" value="8"></el-option>
            <el-option label="公区卫生绿化" value="16"></el-option>
            <el-option label="公区安全" value="17"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" v-show="is400 == false">
          预警级别：
          <el-select v-model="search.is_timeout" placeholder="请选择预警级别" size="mini" clearable @change="searchData">
            <el-option label="-全部-" value=""></el-option>
            <el-option label="一级预警" value="1"></el-option>
            <el-option label="二级预警" value="2"></el-option>
            <el-option label="三级预警" value="3"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          工单来源：
          <el-select v-model="search.member_type" placeholder="请选择工单来源" size="mini" clearable @change="searchData">
            <el-option label="-所有来源-" value=""></el-option>
            <el-option label="业主线上投诉单" value="1"></el-option>
<!--            <el-option label="物业工单" value="2"></el-option>-->
            <el-option label="400电话投诉工单" value="100"></el-option>
<!--            <el-option label="集团品控工单" value="6"></el-option>-->
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          选择日期：
          <el-date-picker
            v-model="search.dateArr[0]"
            type="date"
            @change="searchData"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          至
          <el-date-picker
            v-model="search.dateArr[1]"
            type="date"
            @change="searchData"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-col>
      </el-row>
    </div>
    <v-divider></v-divider>
    <el-tabs v-model="activeName" @tab-click="handleClick" style="margin-left: 20px">
      <el-tab-pane label="数据总览" name="first">
        <div class="body">
          <div class="visit2">
            <div class="visit-title" >业主投诉(天)</div>
            <div class="visit-chart2" id="complaintDay"></div>
          </div>
          <div class="visit2">
            <div class="visit-title">业主投诉预警(天)</div>
            <div class="visit-chart2" id="complaintWarningDay"></div>
          </div>
          <div class="visit2">
            <div class="visit-title">业主投诉(月)</div>
            <div class="visit-chart2" id="complaintMonth"></div>
          </div>
          <div class="visit2">
            <div class="visit-title">业主投诉(前十排名)</div>
            <div class="visit-chart2" id="complaintRanking"></div>
          </div>

          <div style="display:flex;">
            <div class="visit1" style="flex: 1">
              <div class="visit-title">投诉类型分布</div>
              <div class="visit-chart1" id="complaintType"></div>
            </div>
            <div class="visit1" style="flex: 1">

            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="数据列表" name="second">
        <el-table :data="dataList" v-loading="loading" stripe style="width: 100%">
          <el-table-column prop="services_id" label="编号"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="tel" label="电话"></el-table-column>
          <el-table-column prop="house_name" label="项目"></el-table-column>
          <el-table-column prop="address" label="位置"></el-table-column>
          <el-table-column prop="content" label="报修内容" width="200" show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="type_text" label="类型"></el-table-column>
          <el-table-column prop="member_type_text" label="工单来源"></el-table-column>
          <el-table-column prop="is_timeout_text" label="预警"></el-table-column>
          <el-table-column prop="status_text" label="状态"></el-table-column>
          <el-table-column prop="created_at_text" label="提交时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-show="is400 == false" style="color: #FFFFFF" type="primary" size="mini" @click="getDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <v-divider></v-divider>
        <div class="pagination-wrap" >
          <el-pagination background layout="prev, pager, next" :total="search.total*1" :page-size="search.page_size*1" :current-page="search.page_num*1" @current-change="pageChange"></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <repairs-detail ref="RepairsDetail" />
  </div>
</template>

<script>
import RepairsDetail from "../Repair/RepairsDetail";
import Http from "../../Oa/common/OaHttp";
import UserProjectInfo from "../../Butler/common/UserProjectInfo";
import * as echarts from "echarts";
import _ from "lodash";
import SelectCdjProjectHeader from"../../Butler/components/common/SelectCdjProjectHeader"

const statusArr = ['待受理','处理中', '待回访', '待评价', '已完成', '暂挂', '无效工单'];
const statusArr400 = ['待提交', '已提交', '结束', '拒绝'];
export default {
  name: 'Complaints',
  components: {RepairsDetail, SelectCdjProjectHeader},
  data () {
    return {
      activeName: 'first',
      isIndeterminate: false,
      status_total: {
        'status_0' : 0,
        'status_7' : 0,
        'status_3' : 0,
        'status_3000' : 0,
        'status_5' : 0,
        'status_4' : 0,
        'status_2' : 0,
        'total' : 0
      },
      loading: false,
      search: {
        dateArr: [],
        statusList : statusArr,
        status400List : statusArr400,
        select_status: [],
        services_id: '',
        type: '',
        is_timeout: '',
        region:'',
        region_list: [],
        project:'',
        project_list:[],
        page_size: 20,
        page_num: 1,
        total: 0,
        start_date: '',
        end_date: '',
        member_type: '',
        report_type: 'complaints',
        checkAll: false,
        area:'',
        area_list:'',
        project_ids:'',
        type_id : '',
        type_list : []
      },
      dataList : [],
      projectRegion:[],
      projectList:[],
      areaList:[],
      allProjectIds:[],
      regionProjectIds:[],
      regionListKeyById: {},
      is400: false,
      complaintReportGatherLoading: true,
      workOrderUncompletedGatherLoading: true,
      editStatusTotal: false,
      chartTypeData: {}
    }
  },
  //界面没出来前加载
  created() {

  },
  mounted(){
    this.search.dateArr = this.getNowTime();
  },
  activated(){

    // this.search.type_id = 1
    // let that = this
    // UserProjectInfo.ready(function(){
    //   that.search.type_list=UserProjectInfo.getTypeList();
    //   that.search.region_list = UserProjectInfo.getRegionList(that.search.type_id);
    // },1)

  },
  computed:{

  },
  watch: {
    'search':function(newValue) {
      this.searchData()
    },
    'search.dateArr': function (newValue) {
      this.searchData()
    },
    'search.type': function (newValue) {
      this.searchData()
    },
  },
  //事件
  methods: {
    onHeader(data){
      const that=this;
      that.search.type_id=data.type_id;
      that.search.type_list=data.type_list;
      that.search.region=data.project_region;
      that.search.region_list=data.project_region_list;
      that.search.project_region_level=data.project_region_level;
      that.search.project=data.project_name;
      that.search.project_list=data.project_list;
      that.search.group_by=data.group_by;
      that.search.area=data.area_id;
      that.search.area_list=data.area_list;
      that.search.project_ids=data.project_ids;
      that.search.level=data.level;
      that.is_loading=true;

      if (that.search.project) {
        that.search.project_ids =that.search.project;
      }
      this.searchData()
    },
    handleCheckAllChange(val) {
      this.search.select_status = val ? statusArr : [];
      this.isIndeterminate = false;
      this.searchData("handleCheck")
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.search.checkAll = checkedCount === this.search.statusList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.search.statusList.length;
      this.searchData("handleCheck")
    },
    searchData(type = 'all') {
      this.editStatusTotal = false
      if (type != "handleCheck") {
        this.editStatusTotal = true
      }
      this.search.page_num = 1
      // 判断是否400投诉工单
      if (this.search.member_type == 100) {
        this.is400 = true
        this.getC4RecordList()
      } else {
        this.is400 = false
        this.getRepairList()
      }
      if (type == 'all') {
        this.createChart()
      }
    },
    pageChange(i) {
      this.search.page_num = i
      if (this.search.member_type == 100) {
        this.is400 = true
        this.getC4RecordList()
      } else {
        this.is400 = false
        this.getRepairList()
      }
    },
    getRepairList() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      // if (this.search.project_ids == '') {
      //   let projectIds = [];
      //   for (const k in this.search.region_list) {
      //     let item = this.search.region_list[k]
      //     let list = this.getProjectListByRegion(item.id)
      //     projectIds.push(list.map(item => item.erp_pindex_id))
      //   }
      //   this.search.project_ids = projectIds.join(',');
      // }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.loading = true
      this.$myhttp.post('admin/getReportForRepair',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];

        if(resData.code == 200){
          this.search.total = resData.total
          this.dataList = resData.list
          // 统计各个状态数量
          if (this.editStatusTotal) {
            this.status_total = resData.status_total[0]
            if (this.status_total.status_0 == null) {
              this.status_total.status_0 = 0
            }
            if (this.status_total.status_7 == null) {
              this.status_total.status_7 = 0
            }
            if (this.status_total.status_3 == null) {
              this.status_total.status_3 = 0
            }
            if (this.status_total.status_3000 == null) {
              this.status_total.status_3000 = 0
            }
            if (this.status_total.status_5 == null) {
              this.status_total.status_5 = 0
            }
            if (this.status_total.status_4 == null) {
              this.status_total.status_4 = 0
            }
            if (this.status_total.status_2 == null) {
              this.status_total.status_2 = 0
            }
          }
        }
      });
    },
    // 获取400投诉单列表
    getC4RecordList() {
      if (this.search.dateArr.length < 2) {
        this.$message.error("请选择日期");
        return false
      }
      // if (this.search.project_ids == '') {
      //   let projectIds = [];
      //   for (const k in this.search.region_list) {
      //     let item = this.search.region_list[k]
      //     let list = this.getProjectListByRegion(item.id)
      //     projectIds.push(list.map(item => item.erp_pindex_id))
      //   }
      //   this.search.project_ids = projectIds.join(',');
      // }
      this.search.start_date = this.search.dateArr[0];
      this.search.end_date = this.search.dateArr[1];
      this.loading = true
      this.$myhttp.post('admin/getC4RecordRepair',this.search,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loading = false
        let resData = backdata['data'];
        if(resData.code == 200){
          this.search.total = resData.total
          this.dataList = resData.list
          if (this.editStatusTotal) {
            this.status_total = resData.status_total[0]
          }
        }
      });
    },
    getRegionList() {
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/User/getUserProjectInfo", {'status':0}, res => {
        if (res.code == 0) {
          that.projectRegion = this.getRegionTree(0, res.data.region_list)
          that.projectList = res.data.project_list
          that.areaList = res.data.area_list

          for (const k in res.data.region_list) {
            this.regionListKeyById[res.data.region_list[k]['id']] = res.data.region_list[k];
          }

          that.search.region_list = this.getRegionTree(0, res.data.region_list)
          this.getRepairList()
        }
      });
    },
    // 战区列表转为树结构
    getRegionTree(id, d) {
      let list = []
      for(const k in d) {
        if(d[k].pid == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.id, d)
          list.push(item)
        }
      }
      return list
    },
    selectRegion() {
      // this.search.project = '';
      // this.search.area = '';
      // this.search.project_list = this.getProjectListByRegion(this.search.region);
      // this.search.project_ids = this.getProjectIds(this.search);
      this.searchData()
    },
    selectProject() {
      this.search.area = '';
      this.search.area_list = this.getAreaList(this.search.project);
      this.searchData()
    },
    // 获取战区项目列表
    getProjectListByRegion(projectRegionId) {
      if (projectRegionId) {
        const regionItem = this.getRegion(projectRegionId)
        return this.projectList.filter(item => regionItem.pindex_id.includes(item.erp_pindex_id + ''))
      } else {
        return this.projectList
      }
    },

    // 获取项目的区域
    getAreaList(projectId) {
      if (projectId) {
        const projectItem = this.getProject(projectId)
        return this.areaList.filter(item => item.erp_pindex_id == projectItem.erp_pindex_id)
      } else {
        return []
      }
    },

    getRegion(id) {
      // let projectRegion = this.projectRegion
      // for (const k in projectRegion) {
      //   if (projectRegion[k].id == id) {
      //     return projectRegion[k]
      //   }
      // }
      return this.regionListKeyById[id];
    },
    getProject(id) {
      let projectList = this.projectList
      for (const k in projectList) {
        if (projectList[k].erp_pindex_id == id) {
          return projectList[k]
        }
      }
    },
    getProjectIds(data){
      let project_id = '';
      if(data.project) {
        project_id = data.project
      } else {
        if(data.region) {
          const list = this.getProjectListByRegion(data.region)
          project_id = list.map(item => item.erp_pindex_id).join(',')
        } else {
          project_id = this.projectList.map(item => item.erp_pindex_id).join(',')
        }
      }
      return project_id;
    },

    createChart() {
      this.getComplaintDayChart();
      this.getComplaintWarningDayChart();
      this.getComplaintMonthChart();
      this.getComplaintRankingChart();
      this.getComplaintTypeChart();
    },

    getComplaintDayChart() {
      let chartDom = document.getElementById('complaintDay');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.project_ids = this.search.project_ids
      params.group_by = 'day'
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = _.sortBy(resData.list, ['bill_date'])
          let xData = []
          let yData = {}
          let totalData = []
          let finishData = []
          let finishEateData = []
          _.forEach(list, function (item) {
            let finish_rate = (item['all_finish_count'] / item['all_total_count']) * 100
            xData.push(item.date_name)
            totalData.push(item.all_total_count)
            finishData.push(item.all_finish_count)
            finishEateData.push(_.round(finish_rate, 2))
            yData[item.date_name] = item
          })
          let  seriesData = [{
            name: '投诉量',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: totalData
          },{
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: false,
              fontWeight: 'bold',
              position: 'top',
            },
            data: finishEateData
          }]
          let formatter = function (params) {
            let date = params[0]['name'];
            let finish_rate = (yData[date]['all_finish_count'] / yData[date]['all_total_count']) * 100
            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + yData[date]['all_total_count'] + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + _.round(finish_rate, 2) + "%</br>";
            return returnData;
          }
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintWarningDayChart() {
      var chartDom = document.getElementById('complaintWarningDay');
      var myChart = echarts.init(chartDom);
      let params = {}
      params.project_ids = this.search.project_ids
      params.group_by = 'day'
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintWarningDayChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = _.sortBy(resData.list, ['bill_date'])
          let xData = []
          let yData = {}
          let w1 = []
          let w2 = []
          let w3 = []
          _.forEach(list, function (item) {
            xData.push(item.date_name)
            yData[item.date_name] = item
            w1.push(item.all_timeout1_count)
            w2.push(item.all_timeout2_count)
            w3.push(item.all_timeout3_count)
          })


          let  seriesData = [{
            name: '一级预警',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: w1
          },{
            name: '二级预警',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: w2
          },{
            name: '三级预警',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: w3
          }]
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, {})
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintMonthChart() {
      let chartDom = document.getElementById('complaintMonth');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.project_ids = this.search.project_ids
      params.group_by = 'month'
      // 获取第一个日期的年份
      params.year = this.search.start_date.substring(0, 4);
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = _.sortBy(resData.list, ['bill_date'])
          let xData = []
          let yData = {}
          let totalData = []
          let finishData = []
          let finishEateData = []
          _.forEach(list, function (item) {
            let finish_rate = (item['all_finish_count'] / item['all_total_count']) * 100
            xData.push(item.year_month)
            totalData.push(item.all_total_count)
            finishData.push(item.all_finish_count)
            finishEateData.push(_.round(finish_rate, 2))
            yData[item.year_month] = item
          })
          let  seriesData = [{
            name: '投诉量',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: totalData
          },{
            name: '完成率',
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: false,
              fontWeight: 'bold',
              position: 'top'
            },
            data: finishEateData
          }]
          let formatter = function (params) {
            let date = params[0]['name'];
            let finish_rate = (yData[date]['all_finish_count'] / yData[date]['all_total_count']) * 100
            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + yData[date]['all_total_count'] + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + _.ceil(finish_rate, 2) + "%</br>";
            return returnData;
          }
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintRankingChart() {
      let that = this
      let chartDom = document.getElementById('complaintRanking');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.group_by = 'project'
      if (this.search.region > 0) {
        params.group_by = 'project'
      }
      if (this.search.project > 0) {
        params.group_by = 'area'
      }
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.project_ids = this.search.project_ids
      params.type = this.search.type
      this.$myhttp.post('admin/getComplaintChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let list = resData.list
          let xData = []
          let yData = {}
          let totalData = []
          let finishData = []
          _.forEach(list, function (item) {
            if (that.search.project > 0) {
              xData.push(item.area_name)
              yData[item.area_name] = item
            } else {
              xData.push(item.project_name)
              yData[item.project_name] = item
            }
            totalData.push(item.all_total_count)
            finishData.push(item.all_finish_count)
          })
          let  seriesData = [{
            name: '投诉量',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: totalData
          }]
          let formatter = function (params) {
            let date = params[0]['name'];
            let finish_rate = (yData[date]['all_finish_count'] / yData[date]['all_total_count']) * 100
            let returnData = "";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#3399ff"></span>';
            returnData += "工单数：" + yData[date]['all_total_count'] + "</br>";
            returnData += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:#00cc66"></span>';
            returnData += "完成率：" + _.ceil(finish_rate, 2) + "%</br>";
            return returnData;
          }
          let option = this.echartsOptionBar(xData, '日期', yData, '工单数', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    getComplaintTypeChart(){
      let that = this
      this.chartTypeData = {}
      let chartDom = document.getElementById('complaintType');
      let myChart = echarts.init(chartDom);
      let params = {}
      params.start_date = this.search.start_date
      params.end_date = this.search.end_date
      params.project_ids = this.search.project_ids
      this.$myhttp.post('admin/getComplaintTypeChart',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        let resData = backdata['data'];
        if(resData.code == 200){
          // 对数组进行排序
          let item = resData.list[0]
          let yData = {}
          // 计算占比
          this.chartTypeData = item
          let total = parseInt(item.all_ggsw_total_count, 10) + parseInt(item.all_wyfw_total_count, 10) + parseInt(item.all_dcfw_total_count, 10)  + parseInt(item.all_gqaq_total_count, 10)
          let ggsw = item.all_ggsw_total_count === 0 ? 0.00 : _.round((item.all_ggsw_total_count / total) * 100, 2)
          let wyfw = item.all_wyfw_total_count === 0 ? 0.00 : _.round((item.all_wyfw_total_count / total) * 100, 2)
          let dcfw = item.all_dcfw_total_count === 0 ? 0.00 : _.round((item.all_dcfw_total_count / total) * 100, 2)
          let gqaq = item.all_gqaq_total_count === 0 ? 0.00 : _.round((item.all_gqaq_total_count / total) * 100, 2)
          let  seriesData = [ {
            name: '投诉类型分布',
            type: 'pie',
            radius: '50%',
            data: [
              { value: ggsw, name: '公区卫生绿化 ' +  ggsw + '%'},
              { value: wyfw, name: '服务态度 ' +  wyfw + '%' },
              { value: dcfw, name: '公区维修 ' +  dcfw + '%' },
              { value: gqaq, name: '公区安全 ' +  gqaq + '%' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
          let formatter = function (params) {
            let returnData = "";
            let total_count = "";
            let finish_count = "";
            let key = params['name'];
            let checkGgsw = key.includes('公区卫生绿化')
            let checkWyfw = key.includes('服务态度')
            let checkDcfw = key.includes('公区维修')
            if (checkGgsw) {
              total_count = that.chartTypeData.all_ggsw_total_count
              finish_count = that.chartTypeData.all_ggsw_finish_count
            }
            if (checkWyfw) {
              total_count = that.chartTypeData.all_wyfw_total_count
              finish_count = that.chartTypeData.all_wyfw_finish_count
            }
            if (checkDcfw) {
              total_count = that.chartTypeData.all_dcfw_total_count
              finish_count = that.chartTypeData.all_dcfw_finish_count
            }
            returnData = `
                    ${key} <br/><br/>
                        工单量: ${total_count}<br/>
                        已完成: ${finish_count}<br/>
            `
            return returnData;
          }
          let option = this.echartsOptionPie([], '', yData, '', seriesData, formatter)
          option && myChart.setOption(option);
          myChart.resize()
        }
      });
    },
    echartsOptionBar(xData, xTitle, yData, yTitle, seriesData, formatter) {
      let tooltip = {}
      if (typeof formatter === 'function') {
        tooltip = {
          formatter: function (params) {
            return formatter(params)
          }
        }
      }
      tooltip.trigger = 'axis'

      let yAxis = [{
        type: 'value',
        name: yTitle,
        nameGap: 30,
        axisLabel: {
          formatter: '{value}'
        }
      },{
        type: 'value',
        name: '',
        nameGap: 30,
        axisLabel: {
          formatter: '{value}' + '%'
        }
      }]
      let option = {
        tooltip: tooltip,
        legend: {
          show: true
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel:{interval:0,rotate:45,margin:20},
          name: xTitle,
          data: xData,
          axisPointer: {
            type: 'shadow'
          }
        },
        yAxis: yAxis,
        series: seriesData
      }
      return option;
    },
    echartsOptionPie(xData, xTitle, yData, yTitle, seriesData, formatter) {
      let tooltip = {}
      if (typeof formatter === 'function') {
        tooltip = {
          formatter: function (params) {
            return formatter(params)
          }
        }
      }
      tooltip.trigger = 'item'
      let option = {
        tooltip: tooltip,
        legend: {
          show: true
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel:{interval:0,rotate:45,margin:20},
          name: xTitle,
          data: xData,
          axisPointer: {
            type: 'shadow'
          }
        },
        yAxis: {
          type: 'value',
          name: yTitle,
          nameGap: 30,
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: seriesData
      }
      return option;
    },

    getRegionRangeChart(id,url) {
      var chartDom = document.getElementById(id);
      var myChart = echarts.init(chartDom);
      let params = {}
      let where = this.search
      if (id === 'region-ranking') {
        params.project_id = this.allProjectIds
      } else {
        params.project_id = this.regionProjectIds
        params.data_range = [this.search.start_date, this.search.end_date]
      }
      Http.post(url,
        params,
        res => {
          if (res.code) {
            let option = this.regionRangeChartOption(res.data, "战区/片区")
            option && myChart.setOption(option);
            myChart.resize()
          }
        })
    },
    regionRangeChartOption(d, tilte) {
      let xData = d.map((item) => item.name)
      let data = d.map((item) => item.count)

      let width = 45
      let part = 2
      let number = this.getChartItemWidth(width, part)

      return {
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: '60px',
          left: '25px',
          right: '80px',
          bottom: xData.length > number ? '30px' : '10px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: { interval: 0, rotate: 45, margin: 20 },
            name: tilte,
            data: xData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '投诉量',
            nameGap: 30,
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        dataZoom: [{
          type: 'slider',
          show: xData.length > number,
          height: 20,
          xAxisIndex: [0],
          bottom: 0,
          startValue: 0,
          endValue: number - 1,
          moveHandleSize: 10,
          brushSelect: false,
        }],
        series: [
          {
            name: '投诉量',
            type: 'bar',
            //barMaxWidth: 50,
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top',
            },
            data: data
          }
        ]
      }
    },

    getTypeInfoChart(id,url) {
      let that = this
      var chartDom = document.getElementById(id);
      var myChart = echarts.init(chartDom);
      let params = {}
      let where = this.search
      params.data_range = [this.search.start_date, this.search.end_date]
      params.group_by = 'day'
      params.area_name = where.area
      params.repair_type = where.site
      params.project_id = where.project_ids
      Http.post(url,
        params,
        res => {
          if (res.code) {
            let option = this.getTypeInfoOption(res.data)
            option && myChart.setOption(option);
            myChart.resize()
          }
        })
    },
    getTypeInfoOption(data) {
      let typeNames 	= {
        "1": '报修事务',
        "4": '物业服务',
        "8": '地产服务',
        "16": '公共事务',
      }
      let newData = []
      newData.push({name: typeNames[4], value: data['type4']})
      newData.push({name: typeNames[8], value: data['type8']})
      newData.push({name: typeNames[16], value: data['type16']})

      return {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          top: '20px',
          left: '10px',
        },
        series: [
          {
            name: '任务信息',
            type: 'pie',
            center: ['60%', '55%'],
            radius: '60%',
            data: newData,
            //formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
            label: {
              formatter: '{b} {d}%',
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    },

    handleClick(tab, event) {
      if (tab['name'] === "first" && this.search.project_ids != '') {
        this.$nextTick(() => {
          this.createChart()
        });
      }
    },
    getChartItemWidth(width, partNumber = 1) {
      return Math.floor((window.innerWidth / partNumber - 180) / width)
    },
    getDetail(item) {
      this.$refs.RepairsDetail.show(item.id)
    },
    getNowTime() {
      // let start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
      //     .toISOString()
      //     .replace('T', ' ')
      //     .split('.')[0] //默认开始时间7天前

      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      month = month + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let start = year + '-' + month + '-01';

      let end = new Date(new Date().getTime())
        .toISOString()
        .replace('T', ' ')
        .split('.')[0]//默认结束时间

      // start = start.substring(0,10)
      end = end.substring(0, 10)
      return [start, end]
    },
  },

}
</script>
<style scoped>
.el-row {
  margin-bottom: 10px;
}
.ti{
  margin: 1%;
  width: 98%;
}
.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
<style lang="scss" scoped>

.body {
  display: flex;
  flex-direction: column;
  background-color: aliceblue;

  .body-item {
    .body-item-header {
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
    }

    .body-item-main {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.visit1 {
  width: calc(50% - 30px);
  height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart1 {
    width: calc(100% - 30px);
    height: calc(448px - 80px);
  }

  .visit-chart3 {
    width: 400px;
    height: 400px;
  }

  .visit-title {
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-header {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;

    .m-2 {
      width: 100px;
    }
  }
}


.visit2 {
  width: calc(100% - 40px);
  height: calc(520px - 30px);
  margin: 10px;
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart2 {
    width: calc(100% - 40px);
    //width: 800px;
    height: calc(448px - 30px);
  }

  .visit-title {
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-header {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;

    .m-2 {
      width: 100px;
    }
  }
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 9999;
  box-shadow: 0 3px 5px -2px #cccccc69;
}

.chart-item {
  box-sizing: border-box;
  margin: 5px;
  width: calc(100% - 10px);
  background: #fff;
  border-radius: 5px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Complaint/Complaint.vue